////////////////////////////////////////////////////////////////////////////
/////////////// ABOVE WORKING WHEN SAVING MEDIA LINKS //////////////////////
/////////////////// BELOW FOR SAVING MEDIA FILES ///////////////////////////
////////////////////////////////////////////////////////////////////////////
// Working but slow performance
import React, { useCallback, useEffect, useState } from 'react'
import { Grid, Paper, Typography, makeStyles, TextField } from '@material-ui/core';
import Spinner from '../../common/Spinner/Spinner';
import api from '../../utils/api';
import audioIcon from "../../assets/audioIcon.svg"
import audioIcon2 from "../../assets/audioIcon2.svg"
import videoIcon from "../../assets/videoIcon.svg"
import videoIcon2 from "../../assets/videoIcon2.svg"
import textIcon from "../../assets/textIcon.svg"
import textIcon2 from "../../assets/textIcon2.svg"

import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import { Button } from "../../common/Button/Button"
import { toast } from "react-toastify";
import TestimonialUserPersonaModal from './TestimonialUserPersonaModal';
import { DOWNLOAD_API_URL } from '../../utils/constants';
import JPMCTestimonialMainGrid from './JPMCTestimonialMainGrid';
import WysiwygTextEditor from './WysiwygTextEditor';
import { getUser } from '../../utils/localStorage';

// import for wysiwyg
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import TestimonialDeleteConfirmationModel from './TestimonialDeleteConfirmationModel';
import PlayTestimonial from './PlayTestimonial';

// Custom styles
const useStyles = makeStyles(() => ({
    header: {
        backgroundColor: '#75287c',
        color: '#ffffff',
        fontWeight: 'bold',
    },
    row: {
        borderBottom: '1px solid #ccc',
    },
    cell: {
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bordered: {
        borderLeft: '1px solid #ccc',
    },
    firstCell: {
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));


const JPMCTestimonials = () => {
    const classes = useStyles();

    const [hasJpmcAddEditPower, setHasJpmcAddEditPower] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [allUserTestimonials, setAllUserTestimonials] = useState([]);
    const [isTestimonialModalLoading, setIsTestimonialModalLoading] = useState(false)

    const [isTestimonialModalOpen, setIsTestimonialModalOpen] = useState(false);
    const [iconClickedName, setIconClickedName] = useState(null);
    const [addedTestimonials, setAddedTestimonials] = useState(null);
    const [video, setVideo] = useState("");
    const [audio, setAudio] = useState("");
    const [text, setText] = useState("");
    const [textDetail, setTextDetail] = useState("");
    const [isTestimonialEdit, setIsTestimonialEdit] = useState(false)
    const [editedTestimonialVal, setEditedTestimonialVal] = useState("");
    const [editedTextTestimonialDetail, setEditedTextTestimonialTextDetail] = useState("");

    // state and function used for wysiwyg
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [editedEditorState, setEditedEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (newEditorState) => {
        if (isTestimonialEdit) {
            setEditedEditorState(newEditorState);
        }

        if (!isTestimonialEdit) {
            setEditorState(newEditorState);
        }
    };

    // Save content as raw JSON (simulate DB save)
    const saveContent = (unformatedText) => {
        const contentState = unformatedText?.getCurrentContent();
        const raw = convertToRaw(contentState);
        const json = JSON.stringify(raw);

        return json;
    };

    // Load content from raw JSON (simulate DB fetch)
    const loadContent = (editorSavedContent) => {
        if (editorSavedContent) {
            const contentState = convertFromRaw(JSON.parse(editorSavedContent));
            const loadedEditorState = EditorState.createWithContent(contentState);
            return loadedEditorState;
        }
    };

    // modal to open delete conformation model
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteToggleModal, setDleteToggleModal] = useState(false);
    const [deleteApprove, setDeleteApprove] = useState(false);
    const [deleteModalLoading, setDeleteModalLoading] = useState(false);

    const openDeleteModel = () => {
        setIsDeleteModalOpen(true)
    }

    const toggleApproveModel = () => {
        setIsDeleteModalOpen(!isDeleteModalOpen)
    }


    // states for user persona detail modals

    // if mobile number is selected open model, and to close model, set mobile number to null again
    const [selectedNumber, setSelectedNumber] = useState(null);

    const handleMobileClick = (mobile) => {
        setSelectedNumber(mobile);
    }

    const toggleModal = useCallback(() => {
        setSelectedNumber(null);
    }, [selectedNumber])
    ////////////////////////////////////////////

    // main useEffect
    useEffect(() => {
        getAllUserTestimonialFunction();
        const userData = getUser();
        const hasJpmcModelPower = userData?.role?.includes(19)
        setHasJpmcAddEditPower(hasJpmcModelPower)
    }, [])

    // get all user testimonials of JPMC
    const getAllUserTestimonialFunction = async (mobile) => {
        setIsLoading(true);
        try {
            const allTestimonials = await api.getAllTestimonials(mobile);
            console.log(allTestimonials, ">>>>Alltestimonials");

            if (allTestimonials) {
                const seperatingPersonaDetails = allTestimonials?.data?.data.map((user) => {
                    const { persona_details } = user;

                    let allFieldNames = persona_details.map((persona) => {
                        const { field_name, field_value } = persona;
                        user[field_name] = field_value
                    })

                    return user;
                })

                const beneficiaries = seperatingPersonaDetails;

                // beneficiaries.sort((a, b) => {
                //     const nameA = a.FullName?.toLowerCase() || "";
                //     const nameB = b.FullName?.toLowerCase() || "";
                //     return nameA.localeCompare(nameB);
                // });
                beneficiaries.sort((a, b) => {
                    const hasTestimonialA = a.persona_details?.some(
                        (item) => item.Type === "Testimonials"
                    );

                    const hasTestimonialB = b.persona_details?.some(
                        (item) => item.Type === "Testimonials"
                    );

                    if (hasTestimonialA && !hasTestimonialB) return -1;
                    if (!hasTestimonialA && hasTestimonialB) return 1;

                    const nameA = a.FullName?.toLowerCase() || "";
                    const nameB = b.FullName?.toLowerCase() || "";

                    return nameA.localeCompare(nameB);
                });
                
                setAllUserTestimonials(beneficiaries);
                setIsLoading(false);
            }

            setIsLoading(false);
        } catch (err) {
            toast(String("Error getting testimonials"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setIsLoading(false);
        }
    }

    const handleCancelUploadNew = useCallback(() => {
        setVideo(null);
        setAudio(null);
        setText(null)
        setIconClickedName(null);
        setIsTestimonialModalOpen(false);
        setEditedTestimonialVal("");
        setIsTestimonialEdit(false);
        setEditorState("");
        setEditedEditorState("")
    }, [video, audio, text, iconClickedName, isTestimonialModalOpen, editedTestimonialVal, isTestimonialEdit])

    const handleTestimonialIconClick = useCallback((e, user) => {
        console.log(user, ">>>>user aka addedTestimonials on iconCLick");

        setIsTestimonialModalLoading(false)
        const iconName = e.target.name;
        const value = iconName === "video" ? user?.Video : iconName === "audio" ? user?.Audio : user?.Text;
        const textDetailVal = iconName === "text" ? user?.TextDetail : "";
        console.log(value, ">>>Value on icon click function called");

        let formattedData = loadContent(textDetailVal);


        // Set the state first
        setIconClickedName(iconName);
        setAddedTestimonials(user);
        setEditedTestimonialVal(value || "");
        setEditedTextTestimonialTextDetail(textDetailVal);
        setEditedEditorState(formattedData);
        setIsTestimonialModalOpen(true)
    }, [iconClickedName])


    const editTestimonialClicked = useCallback(() => {
        console.log(">>>edit tetimonial clicked");
        setIsTestimonialEdit(true)
    }, [isTestimonialEdit])

    // Update testimonial
    const updateTestimonial = async (payload, iconClickedName) => {
        console.log(iconClickedName, ">>>>>iconClickedName on update testimonial");

        try {
            setIsTestimonialModalLoading(true)
            const updateTestimonial = await api.updatePersonaDetail(payload)

            if (updateTestimonial) {
                toast(String(`${iconClickedName} testimonal updated successfully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });

                console.log(payload.sMobile, ">>>>>payload.sMobile try");

                getAllUserTestimonialFunction();
                setEditedTestimonialVal("");
                setEditedTextTestimonialTextDetail("");
                setEditedEditorState("")
                setIsTestimonialModalOpen(false);
                setIconClickedName(null);
                setIsTestimonialEdit(false);
                setIsTestimonialModalLoading(false);
                setText("");
                setEditorState("");
                setEditedEditorState("")
            }
        } catch {
            console.log(payload.sMobile, ">>>>>payload.sMobile catch");
            toast(String(`${iconClickedName} testimonal not updated`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setEditedTestimonialVal("");
            setEditedTextTestimonialTextDetail("");
            setEditedEditorState("")
            setIsTestimonialModalOpen(false);
            setIconClickedName(null);
            setIsTestimonialEdit(false);
            setIsTestimonialModalLoading(false);
            setText("");
            setEditorState("");
            setEditedEditorState("")
        }
    }

    const handleUpdateTestimonial = () => {
        console.log(">>>>text update button clicked");
        console.log(iconClickedName, ">>>>iconClickedName");
        console.log(editedTestimonialVal, ">>>>editedTestimonialVal");
        console.log(editedEditorState, ">>>>editedEditorState");




        if (iconClickedName == "text") {
            if (editedTestimonialVal || editedEditorState) {
                const { nUserId, sMobile, nEntryId } = addedTestimonials;

                if (editedTestimonialVal && editedEditorState) {
                    const convertedWysiwygToJson = saveContent(editedEditorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal, "TextDetail": convertedWysiwygToJson } };
                    updateTestimonial(payload, iconClickedName)
                } else if (editedTestimonialVal && !editedEditorState) {
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal, "TextDetail": "" } };
                    updateTestimonial(payload, iconClickedName)
                } else if (editedEditorState && !editedTestimonialVal) {
                    const convertedWysiwygToJson = saveContent(editedEditorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": "", "TextDetail": convertedWysiwygToJson } };
                    updateTestimonial(payload, iconClickedName)
                }
            }
        }
    }

    // Add Testimonial
    const addTestimonialFunction = async (payload, testimonialType) => {
        try {
            setIsTestimonialModalLoading(true)
            const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
            console.log(res, ">>>>res on upload audio");

            if (res) {
                toast(String(`${testimonialType} testimonal saved successfully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                getAllUserTestimonialFunction();
                setVideo("");
                setAudio("");
                setText("");
                setIsTestimonialModalOpen(false);
                setIsTestimonialModalLoading(false)
                setEditorState("");
                setEditedEditorState("")
            }
        } catch (err) {
            toast(String(`${testimonialType} not added`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo("");
            setAudio("");
            setText("");
            setIsTestimonialModalLoading(false)
            setEditorState("");
            setEditedEditorState("")
        }
    }

    const handleAddTestimonial = async (testimonialType) => {
        console.log(testimonialType, ">>>>testimonialType");
        console.log(text, ">>>>>text");
        console.log(editorState, ">>>editorState");

        // if (testimonialType == "video" && video) {
        //     console.log(video, ">>>>video");
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": video } };
        //     addTestimonialFunction(payload, testimonialType)
        // }

        // if (testimonialType == "audio" && audio) {
        //     console.log(audio, ">>>>audio");
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": audio } };
        //     addTestimonialFunction(payload, testimonialType)
        // }

        if (testimonialType == "text") {

            if (text || editorState) {
                console.log(text, ">>>>text");
                const { nUserId, sMobile, nEntryId } = addedTestimonials;

                if (text && editorState) {
                    const convertedWysiwygToJson = saveContent(editorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text, "TextDetail": convertedWysiwygToJson } };
                    addTestimonialFunction(payload, testimonialType);
                } else if (text && !editorState) {
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text, "TextDetail": "" } };
                    addTestimonialFunction(payload, testimonialType);
                } else if (editorState && !text) {
                    const convertedWysiwygToJson = saveContent(editorState);

                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": "", "TextDetail": convertedWysiwygToJson } };
                    addTestimonialFunction(payload, testimonialType);
                }
            }

        }
    }


    // Delete Testimonial
    const deleteTestimonialFunction = async (payload, deleteTestimonialType) => {
        console.log(payload, ">>>>delete testi oayload");

        try {
            setIsTestimonialModalLoading(true)
            setIsDeleteModalOpen(false);
            const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetails(payload)

            if (deleteTestimonialResponse) {
                toast(String(`${deleteTestimonialType} testimonial deleted successully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                getAllUserTestimonialFunction();
                setVideo("");
                setAudio("");
                setText("");
                setIconClickedName(null)
                setIsTestimonialModalOpen(false);
                setIsTestimonialModalLoading(false);
            }
        } catch (err) {
            setIsDeleteModalOpen(false);
            toast(String(`${deleteTestimonialType} testimonial not deleted`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo("");
            setAudio("");
            setText("");
            setIconClickedName(null)
            setIsTestimonialModalOpen(false);
        }
    }
    const handleDelete = async (deleteTestimonialType) => {
        console.log(deleteTestimonialType, ">>>deleteTestimonialType");

        // if (deleteTestimonialType == "video") {
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": addedTestimonials?.Video } };
        //     deleteTestimonialFunction(payload, deleteTestimonialType)
        // }

        // if (deleteTestimonialType == "audio") {
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": addedTestimonials?.Audio } };
        //     deleteTestimonialFunction(payload, deleteTestimonialType)
        // }

        if (deleteTestimonialType == "text") {
            toggleApproveModel()
            const { nUserId, sMobile, nEntryId } = addedTestimonials;

            // const convertedWysiwygToJson = saveContent();

            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": addedTestimonials?.Text, "TextDetail": addedTestimonials?.TextDetail } };
            deleteTestimonialFunction(payload, deleteTestimonialType);
        }
    }

    // Play testimonial in modal
    const [isPlayModalOpen, setIsPlayModalOpen] = useState(false);

    const openPlayModal = () => {
        setIsPlayModalOpen(!isPlayModalOpen);
    }

    // Search feature
    const [searchTerm, setSearchTerm] = useState("");
    const [searchedTestimonial, setSearcedTestimonial] = useState("");

    const handleSearchInputChange = useCallback((e) => {
        console.log(e.target.value, ">>>>>>>search val change");

        setSearchTerm(e.target.value)
    }, [])

    const onSearchClicked = () => {
        console.log(searchTerm, ">>>searchTerm on searchClicked");

        if (searchTerm) {
            let testimonialSearched = allUserTestimonials.filter((user) => user.sMobile == searchTerm)

            console.log(testimonialSearched, ">>>testimonialSearched");


            if (testimonialSearched) {
                setSearcedTestimonial(testimonialSearched)
            } else {
                setSearcedTestimonial(null)
            }
        } else {
            setSearcedTestimonial(null)
        }
    }

    const onClearClicked = () => {
        setSearchTerm("");
        setSearcedTestimonial(null)
    }

    // MEDIA FILE UPLOAD
    // Add (upload) Video
    const [videoFile, setVideoFile] = useState(null);
    const [audioFile, setAudioFile] = useState(null);

    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("video/")) {
            setVideoFile(file);
        } else {
            alert("Please select a valid video file.");
        }
    };

    const handleAudioChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("audio/")) {
            setAudioFile(file);
        } else {
            alert("Please select a valid video file.");
        }
    };


    const handleAddTestimonialVideo = async (testimonialType) => {
        if (testimonialType == "video" && videoFile) {
            console.log(videoFile, ">>>>videoFile");

            if (!videoFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Video", videoFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await addTestimonialFunctionVideo(formData, "video");
        }

        if (testimonialType == "audio" && audioFile) {
            console.log(audioFile, ">>>>audioFile");

            if (!audioFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Audio", audioFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await addTestimonialFunctionVideo(formData, "audio");
        }
    };


    const addTestimonialFunctionVideo = async (formData, testimonialType) => {
        try {
            setIsTestimonialModalLoading(true);

            const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetailsVideo(formData);

            if (res) {
                toast(`${testimonialType} testimonial saved successfully`, {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                getAllUserTestimonialFunction();
                setVideoFile(null);
                setIsTestimonialModalOpen(false);
            }
        } catch (err) {
            toast(`${testimonialType} not added`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } finally {
            setIsTestimonialModalLoading(false);
        }
    };


    // Edit Video
    const handleEditTestimonialVideo = async (testimonialType) => {
        if (testimonialType == "video" && videoFile) {
            console.log(videoFile, ">>>>videoFile");

            if (!videoFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Video", videoFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await editTestimonialFunctionVideo(formData, "video");
        }

        if (testimonialType == "audio" && audioFile) {
            console.log(audioFile, ">>>>audioFile");

            if (!audioFile) {
                alert("Please select a video first.");
                return;
            }

            const { nUserId, sMobile, nEntryId } = addedTestimonials;

            const formData = new FormData();
            formData.append("nUserId", nUserId);
            formData.append("sMobile", sMobile);
            formData.append("Type", "Testimonials");
            formData.append("subType", "Testimonials");
            formData.append("nResourceInstanceId", nEntryId);
            formData.append("Audio", audioFile); // File key matches backend field

            // logging the form data
            const debugPayload = {};
            formData.forEach((value, key) => {
                debugPayload[key] = value;
            });

            console.log(">>>>>>FormData Debug:", debugPayload);
            await editTestimonialFunctionVideo(formData, "audio");
        }
    };


    const editTestimonialFunctionVideo = async (formData, testimonialType) => {
        try {
            setIsTestimonialModalLoading(true);

            const res = await api.jpmcThreeSixtyDegreeViewEditPersonaDetailsVideo(formData);

            if (res) {
                toast(`${testimonialType} testimonial updated successfully`, {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                getAllUserTestimonialFunction();
            }
        } catch (err) {
            toast(`${testimonialType} not added`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        } finally {
            setIsTestimonialModalLoading(false);
            setVideoFile(null);
            setAudioFile(null);
            // setIconClickedName(null);
            setIsTestimonialModalOpen(false);
            setIsTestimonialEdit(false);
        }
    };

    // Delete Video
    const handleDeleteVideo = async (deleteTestimonialType) => {
        console.log(deleteTestimonialType, ">>>deleteTestimonialType");
        toggleApproveModel();

        if (deleteTestimonialType == "video") {
            const { nUserId, sMobile, nEntryId } = addedTestimonials;
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": addedTestimonials?.Video } };
            deleteTestimonialFunctionVideo(payload, deleteTestimonialType)
        }

        if (deleteTestimonialType == "audio") {
            const { nUserId, sMobile, nEntryId } = addedTestimonials;
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": addedTestimonials?.Audio } };
            deleteTestimonialFunctionVideo(payload, deleteTestimonialType)
        }

        // if (deleteTestimonialType == "text") {
        //     const { nUserId, sMobile, nEntryId } = addedTestimonials;
        //     const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": addedTestimonials?.Text } };
        //     deleteTestimonialFunctionVideo(payload, deleteTestimonialType)
        // }
    }

    const deleteTestimonialFunctionVideo = async (payload, deleteTestimonialType) => {
        console.log(payload, ">>>>delete testi oayload");

        try {
            setIsTestimonialModalLoading(true)
            const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetailsVideo(payload)

            if (deleteTestimonialResponse) {
                toast(String(`${deleteTestimonialType} testimonial deleted successully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                getAllUserTestimonialFunction();
                // setVideo("");
                // setAudio("");
                // setText("");
                setAudioFile(null);
                setVideoFile(null);
                setIconClickedName(null);
                setIsTestimonialModalOpen(false);
                setIsTestimonialModalLoading(false);

                // setIsDeleteModalOpen(false)
            }
        } catch (err) {
            toast(String(`${deleteTestimonialType} testimonial not deleted`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            // setVideo("");
            // setAudio("");
            // setText("");
            setAudioFile(null);
            setVideoFile(null);
            setIconClickedName(null);
            setIsTestimonialModalOpen(false);
            setIsTestimonialModalLoading(false);
            // setIsDeleteModalOpen(false)
        }
    }

    // function to make first letter capital
    const firstLetterCase = (text) => {
        console.log(text);

        if (text) {
            let splitString = text?.split("");
            console.log(splitString, ">>>>splitString");

            let firstLetter = splitString[0].toUpperCase();
            console.log(firstLetter, ">>>>firstLetter");

            let remainingLetter = splitString.slice(1).join("");
            console.log(remainingLetter, ">>>>remainingLetter");


            return firstLetter + remainingLetter
        }
    }





    console.log(editedTestimonialVal, ">>>>editedTestimonialVal");
    // console.log(allUserTestimonials, ">>>>>allUserTestimonials");
    console.log(addedTestimonials, ">>>>>addedTestimonials");
    console.log(textDetail, ">>>>textDetail");
    console.log(text, ">>>>text");
    console.log(editedTestimonialVal, ">>>>editedTestimonialVal");
    console.log(editedTextTestimonialDetail, ">>>>editedTextTestimonialDetail");
    return (
        <>
            <div>
                {/* Search Bar */}
                <div className="row conv-mt20 conv-pl20">
                    <div className="col-12">
                        <div className="conv-pr5 conv-mr15  conv-align-self-center conv-float-left">
                            <div className="">
                                <button
                                    style={{ marginLeft: "30px" }}
                                    className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                                    onClick={onClearClicked}
                                >
                                    Clear
                                </button>
                                <button
                                    className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                                    onClick={onSearchClicked}
                                >
                                    Search
                                </button>
                                <input
                                    type="number"
                                    className="conv-float-right form-control conv-h250rem search-input "
                                    placeholder="Search"
                                    onChange={(e) => handleSearchInputChange(e)}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            onSearchClicked();
                                        }
                                    }}
                                    autoComplete={false}
                                    value={searchTerm}
                                    name="searchTerm"
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <div className={`${isLoading && "set-opacity"} conv-pl20`}>
                    {isLoading && <Spinner className="center-screen" />}

                    <JPMCTestimonialMainGrid
                        allUserTestimonials={allUserTestimonials}
                        searchedTestimonial={searchedTestimonial}
                        handleMobileClick={handleMobileClick}
                        handleTestimonialIconClick={handleTestimonialIconClick}
                    />

                </div>
            </div>

            {/* Below are modals */}
            {isTestimonialModalOpen && (
                <Modal isOpen={true}>
                    <ModalContent className="jpmc-testimonials-modal">
                        <div className="modal-header" style={{
                            // backgroundColor: '#76287C',
                            color: '#fff'
                        }}>
                            <span className="modal-title">{`${firstLetterCase(iconClickedName)} Testimonial`}</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                // onClick={()=>handleCloseSmsModel(false)}
                                onClick={handleCancelUploadNew}
                            />
                        </div>

                        <div className={`modal-body ${isTestimonialModalLoading && "set-opacity"}`} style={{ backgroundColor: "" }}>
                            {isTestimonialModalLoading && <Spinner className="center" />}
                            <div style={{ height: "100%" }}>
                                {/* {loadingInModal && <Spinner className="center" />} */}
                                <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "", height: "100%" }}>
                                    {
                                        <div className="" style={{
                                            // height: "300px",
                                            // height: iconClickedName == "text" ? "600px" : "300px",
                                            height: "100%",
                                            backgroundColor: "",
                                            padding: "3px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between"
                                        }}>
                                            <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                                {
                                                    <div style={{ marginBottom: '20px', width: '100%', backgroundColor: "" }}>
                                                        {
                                                            addedTestimonials?.Video ? (
                                                                iconClickedName == "video" &&
                                                                (
                                                                    <>
                                                                        {
                                                                            !isTestimonialEdit ? (
                                                                                <TextField
                                                                                    name="Video Testimonial"
                                                                                    label="Video Testimonial"
                                                                                    value={isTestimonialEdit ? editedTestimonialVal : addedTestimonials?.Video || ""}
                                                                                    onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                    disabled={true}
                                                                                />
                                                                            ) : (
                                                                                <input
                                                                                    type="file"
                                                                                    accept="video/*"
                                                                                    onChange={handleVideoChange}
                                                                                    style={{ marginBottom: "10px" }}
                                                                                    disabled={isTestimonialEdit ? false : true}
                                                                                />
                                                                            )
                                                                        }
                                                                    </>

                                                                )
                                                            ) : (
                                                                iconClickedName == "video" &&
                                                                (
                                                                    <>
                                                                        {/* <TextField
                                                                            name="Add Video Testimonial"
                                                                            label="Add Video Testimonial"
                                                                            value={video ? video : ""}
                                                                            onChange={(e) => setVideo(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                        /> */}

                                                                        {/* <br /> */}

                                                                        <input
                                                                            type="file"
                                                                            accept="video/*"
                                                                            onChange={handleVideoChange}
                                                                            style={{ marginBottom: "10px" }}
                                                                        />
                                                                    </>
                                                                )
                                                            )
                                                        }

                                                        {
                                                            addedTestimonials?.Audio ? (
                                                                iconClickedName == "audio" && (
                                                                    <>
                                                                        {
                                                                            !isTestimonialEdit ? (
                                                                                <TextField
                                                                                    name="Audio Testimonial"
                                                                                    label="Audio Testimonial"
                                                                                    value={isTestimonialEdit ? editedTestimonialVal : addedTestimonials?.Audio}
                                                                                    onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                    disabled={true}
                                                                                />
                                                                            ) : (
                                                                                <input
                                                                                    type="file"
                                                                                    accept="audio/*"
                                                                                    onChange={handleAudioChange}
                                                                                    style={{ marginBottom: "10px" }}
                                                                                    disabled={isTestimonialEdit ? false : true}
                                                                                />
                                                                            )
                                                                        }

                                                                    </>
                                                                )
                                                            ) : (
                                                                iconClickedName == "audio" && (
                                                                    <>
                                                                        {/* <TextField
                                                                            name="Add Audio Testimonial"
                                                                            label="Add Audio Testimonial"
                                                                            value={audio ? audio : ""}
                                                                            onChange={(e) => setAudio(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                        /> */}

                                                                        {/* <br /> */}

                                                                        <input
                                                                            type="file"
                                                                            accept="audio/*"
                                                                            onChange={handleAudioChange}
                                                                            style={{ marginBottom: "10px" }}
                                                                        />
                                                                    </>
                                                                )




                                                            )
                                                        }

                                                        {
                                                            addedTestimonials?.Text || addedTestimonials?.TextDetail ? (
                                                                iconClickedName == "text" && (
                                                                    <>
                                                                        <WysiwygTextEditor
                                                                            // editorState={editorState}
                                                                            editorState={isTestimonialEdit ? editedEditorState : loadContent(addedTestimonials?.TextDetail)}
                                                                            onEditorStateChange={onEditorStateChange}
                                                                        />

                                                                        <br />

                                                                        {/* <TextField
                                                                            name="Add Text Testimonial"
                                                                            label="Add Text Testimonial"
                                                                            value={isTestimonialEdit ? editedTextTestimonialDetail : addedTestimonials?.TextDetail}
                                                                            onChange={(e) => setEditedTextTestimonialTextDetail(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            multiline
                                                                            minRows={4}
                                                                            disabled={isTestimonialEdit ? false : true}
                                                                        /> */}

                                                                        <TextField
                                                                            name="Testimonial from Google form"
                                                                            label="Testimonial from Google form"
                                                                            value={isTestimonialEdit ? editedTestimonialVal : addedTestimonials?.Text}
                                                                            onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            disabled={isTestimonialEdit ? false : true}
                                                                        />
                                                                    </>
                                                                )
                                                            ) : (
                                                                iconClickedName == "text" && (
                                                                    <>
                                                                        <WysiwygTextEditor
                                                                            editorState={editorState}
                                                                            onEditorStateChange={onEditorStateChange}
                                                                        />

                                                                        <br />

                                                                        {/* <TextField
                                                                            name="Add Text Testimonial"
                                                                            label="Add Text Testimonial"
                                                                            value={textDetail}
                                                                            onChange={(e) => setTextDetail(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            multiline
                                                                            minRows={4}
                                                                        /> */}

                                                                        <TextField
                                                                            name="Testimonial from Google form"
                                                                            label="Testimonial from Google form"
                                                                            value={text ? text : ""}
                                                                            onChange={(e) => setText(e.target.value)}
                                                                            fullWidth
                                                                            margin="normal"
                                                                        />
                                                                    </>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                                }
                                            </div>

                                            <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                                <div className="col-12 mt-3 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>

                                                    {/* if testimonial exist- edit, open,cancel and if not only add and cancel */}
                                                    {
                                                        iconClickedName == "video" && (
                                                            addedTestimonials.Video ?
                                                                <>
                                                                    {
                                                                        hasJpmcAddEditPower && (
                                                                            isTestimonialEdit ?
                                                                                <Button onClick={() => handleEditTestimonialVideo("video")} disabled={!videoFile}>Update</Button>
                                                                                :
                                                                                <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                        )

                                                                    }

                                                                    {/* when text */}
                                                                    {/* <Button>
                                                                        <a href={addedTestimonials?.Video} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}

                                                                    {/* When media file */}
                                                                    {/* <Button disabled={isTestimonialEdit}>
                                                                        <a disabled={isTestimonialEdit} href={`${DOWNLOAD_API_URL}/static_live/Testimonials/${addedTestimonials?.Video}`} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}

                                                                    <Button disabled={isTestimonialEdit} onClick={openPlayModal}>
                                                                        <a disabled={isTestimonialEdit} style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button>

                                                                    {
                                                                        // hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => handleDeleteVideo("video")}>Delete</Button>
                                                                        hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => openDeleteModel()}>Delete</Button>
                                                                    }

                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        <Button onClick={() => handleAddTestimonialVideo("video")}>Upload</Button>
                                                                    }
                                                                </>

                                                        )
                                                    }

                                                    {
                                                        iconClickedName == "audio" && (
                                                            addedTestimonials.Audio ?
                                                                <>
                                                                    {
                                                                        hasJpmcAddEditPower && (
                                                                            isTestimonialEdit ?
                                                                                <Button onClick={() => handleEditTestimonialVideo("audio")} disabled={!audioFile}>Update</Button>
                                                                                :
                                                                                <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                        )

                                                                    }

                                                                    {/* when text */}
                                                                    {/* <Button>
                                                                        <a href={addedTestimonials?.Audio} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}

                                                                    {/* When media file */}
                                                                    {/* <Button disabled={isTestimonialEdit}>
                                                                        <a disabled={isTestimonialEdit} href={`${DOWNLOAD_API_URL}/static_live/Testimonials/${addedTestimonials?.Audio}`} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button> */}

                                                                    <Button disabled={isTestimonialEdit} onClick={openPlayModal}>
                                                                        <a disabled={isTestimonialEdit} style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button>

                                                                    {
                                                                        hasJpmcAddEditPower && <Button disabled={isTestimonialEdit} onClick={() => openDeleteModel()}>Delete</Button>
                                                                    }

                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        <Button onClick={() => handleAddTestimonialVideo("audio")}>Upload</Button>
                                                                    }
                                                                </>
                                                        )
                                                    }

                                                    {
                                                        iconClickedName == "text" && (
                                                            addedTestimonials.Text || addedTestimonials.TextDetail ?
                                                                <>
                                                                    {
                                                                        hasJpmcAddEditPower && (
                                                                            isTestimonialEdit ?
                                                                                <Button onClick={handleUpdateTestimonial}>Update</Button>
                                                                                :
                                                                                <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                        )

                                                                    }

                                                                    <Button>
                                                                        <a href={addedTestimonials?.Text} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                    </Button>

                                                                    {
                                                                        hasJpmcAddEditPower && <Button onClick={() => openDeleteModel()}>Delete</Button>
                                                                    }

                                                                </>
                                                                :
                                                                <>
                                                                    {
                                                                        <Button onClick={() => handleAddTestimonial("text")}>Add</Button>
                                                                    }
                                                                </>

                                                        )
                                                    }
                                                    <Button onClick={handleCancelUploadNew}>Cancel</Button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div style={{ color: "red" }}>
                                    <small>
                                        <i>
                                            {
                                                isTestimonialEdit && <span><strong>Note: </strong></span>
                                            }
                                            {iconClickedName === "video" && isTestimonialEdit && (
                                                <span>
                                                    Editing a video testimonial is <strong>permanent</strong> and will replace the existing file. The original cannot be recovered.
                                                </span>
                                            )}
                                            {iconClickedName === "audio" && isTestimonialEdit && (
                                                <span>
                                                    Editing an audio testimonial is <strong>permanent</strong> and will overwrite the current recording. This action cannot be undone.
                                                </span>
                                            )}
                                            {iconClickedName === "text" && isTestimonialEdit && (
                                                <span>
                                                    Editing a text testimonial is <strong>permanent</strong> and will replace the existing content. Changes cannot be reversed.
                                                </span>
                                            )}
                                        </i>
                                    </small>

                                </div>


                            </div>
                        </div>
                    </ModalContent>
                </Modal>
            )}

            {/* User Persona Modal */}
            {
                selectedNumber && <TestimonialUserPersonaModal
                    selectedNumber={selectedNumber}
                    toggleModal={toggleModal}
                />

            }

            {/* Delete confirmation model */}
            {
                isDeleteModalOpen && <TestimonialDeleteConfirmationModel
                    isOpen={isDeleteModalOpen}
                    setIsDeleteModalOpen={setIsDeleteModalOpen}
                    toggleModal={toggleApproveModel}
                    // deleteApprove={deleteApprove}
                    // deleteModalLoading={deleteModalLoading}

                    iconClickedName={iconClickedName}
                    handleDelete={handleDelete} // to delete text
                    handleDeleteVideo={handleDeleteVideo} // to delete audio and video
                />
            }

            {/* Play Modal */}
            {
                iconClickedName == "video" && isPlayModalOpen && (
                    <PlayTestimonial
                        isPlayModalOpen={isPlayModalOpen}
                        openPlayModal={openPlayModal}
                        // media={{ type: iconClickedName, url: "https://example.com/video.mp4" }}
                        media={{ type: iconClickedName, url: `${DOWNLOAD_API_URL}/static_live/Testimonials/${addedTestimonials?.Video}` }}
                    />
                )
            }

            {
                iconClickedName == "audio" && isPlayModalOpen && (
                    <PlayTestimonial
                        isPlayModalOpen={isPlayModalOpen}
                        openPlayModal={openPlayModal}
                        // media={{ type: iconClickedName, url: "https://example.com/video.mp4" }}
                        media={{ type: iconClickedName, url: `${DOWNLOAD_API_URL}/static_live/Testimonials/${addedTestimonials?.Audio}` }}
                    />
                )
            }

        </>
    )
}

export default JPMCTestimonials